import { FORM_BUILDER_FIELD_TYPE } from "@loanbossinc/component-library";

import { isFieldReadOnly } from "./section-property-financials-rows-logic";

const asOfDateLabel = "As of Date";

export const rows = {
  title: {
    label: "Property Financials",
    isTitle: true
  },
  noiActual: {
    label: "NOI (Actual)",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DOLLAR,
        name: "noiActual",
        variant: "filled",
        isDisabled: data => isFieldReadOnly(data, "property.noiActual")
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.ACCOUNTING_INTEGRATION,
        accountingIntegrationFieldPath: "property.noiActual"
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.ACCOUNTING_INTEGRATION,
        accountingIntegrationFieldPath: "property.noiActual",
        fieldLabelOnly: true
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.DATE,
        name: "noiActualAsOfDate",
        variant: "filled",
        label: asOfDateLabel,
        decimals: 2,
        style: { marginTop: "15px", width: "80px" }
      }
    ]
  },

  noi: {
    label: "NOI (Lender)",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DOLLAR,
        name: "noi",
        variant: "filled"
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.DATE,
        name: "noiAsOfDate",
        variant: "filled",
        label: asOfDateLabel,
        decimals: 2,
        style: { marginTop: "15px", width: "80px" }
      }
    ]
  },

  occupancy: {
    label: "Occupancy",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.PERCENT,
        name: "occupancy",
        variant: "filled",
        decimals: 3,
        isDisabled: data => isFieldReadOnly(data, "property.occupancy")
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.ACCOUNTING_INTEGRATION,
        accountingIntegrationFieldPath: "property.occupancy"
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.ACCOUNTING_INTEGRATION,
        accountingIntegrationFieldPath: "property.occupancy",
        fieldLabelOnly: true
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.DATE,
        name: "occupancyAsOfDate",
        variant: "filled",
        label: asOfDateLabel,
        decimals: 2,
        style: { marginTop: "15px", width: "80px" }
      }
    ]
  },

  marketValue: {
    label: "Market Value",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DOLLAR,
        name: "marketValue",
        variant: "filled"
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.DATE,
        name: "marketValueAsOfDate",
        variant: "filled",
        label: asOfDateLabel,
        decimals: 2,
        style: { marginTop: "15px", width: "80px" }
      }
    ]
  },

  appraisedValue: {
    label: "Appraised Value",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DOLLAR,
        name: "appraisedValue",
        variant: "filled"
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.DATE,
        name: "appraisedValueAsOfDate",
        variant: "filled",
        label: asOfDateLabel,
        decimals: 2,
        style: { marginTop: "15px", width: "80px" }
      }
    ]
  },

  bov: {
    label: "Broker Opinion of Value",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DOLLAR,
        name: "brokerOpinionValue",
        variant: "filled"
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.DATE,
        name: "brokerOpinionValueAsOfDate",
        variant: "filled",
        label: asOfDateLabel,
        decimals: 2,
        style: { marginTop: "15px", width: "80px" }
      }
    ]
  },
};
